// @ts-expect-error: @rails/request.js is not typed
import { FetchRequest } from '@rails/request.js'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import { getBasePaySchedulesQuery } from './payroll/utils'

export function useDeactivatePaySchedule () {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (payScheduleId: string) => {
      const request = new FetchRequest(
        'delete',
        '/api/web/payroll/pay_schedules/deactivate',
        {
          body: JSON.stringify({ pay_schedule_id: payScheduleId }),
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )

      const response = await request.perform()
      if (!response.ok) {
        const error = await response.json
        throw new Error(error.message || 'Failed to deactivate pay schedule')
      }

      return response.json
    },
    onSuccess: () => {
      // Invalidate and refetch pay schedules query
      queryClient.invalidateQueries({ queryKey: getBasePaySchedulesQuery() })
      toast.success('Pay schedule deactivated successfully')
    },
    onError: (error: Error) => {
      toast.error(error.message)
    },
  })
}
